import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  advShipFServ02ShowSyncSetting: null,
  advShipFServ02ShowSyncSettingLoading: ['boolean'],
  advShipFServ02ShowSyncSettingSuccess: ['syncSetting'],
  advShipFServ02UpdateSyncSetting: ['formikBag', 'syncSetting'],
  advShipFServ02ShowBatchJobStatus: null,
  advShipFServ02ShowBatchJobStatusSuccess: ['batchJobStatus'],

  advShipFServ02ResetTimestamp: ['currentPage', 'sorts', 'filters', 'pageSize'],
  advShipFServ02GoToDocument: ['hdrId'],
  advShipFServ02FetchAdvShipFServ02: ['currentPage', 'sorts', 'filters', 'pageSize'],
  advShipFServ02FetchAdvShipFServ02Loading: ['boolean'],
  advShipFServ02FetchAdvShipFServ02Success: [
    'documents',
    'currentPage',
    'lastPage',
    'total',
    'pageSize'
  ],
  advShipFServ02AddSelectedDocuments: ['selectedDocuments'],
  advShipFServ02RemoveSelectedDocuments: ['selectedDocuments'],
  advShipFServ02SetWorkspaceVisible: ['boolean'],

  advShipFServ02Export: ['hdrIds'],
  advShipFServ02ExportSuccess: null,
  advShipFServ02ExportLoading: ['boolean']
});

export const AdvShipFServ02Types = Types;
export default Creators;
